<template>
  <a-layout class="fonts">
    <a-layout-header class="fonts__header">
      <a-button icon="cloud-upload" @click="uploadFont" block>
        Upload Font
      </a-button>
    </a-layout-header>
    <a-layout-content class="fonts__content">
      <a-table :columns="columns" :data-source="data">
        <span slot="name" slot-scope="name" :style="{ fontFamily: name }">
          {{ name }}
        </span>
        <div class="fonts__item--centered" slot="src" slot-scope="src">
          <a :href="src">
            <a-icon type="download" />
          </a>
        </div>
        <div class="fonts__item--centered" slot="destroy" slot-scope="id">
          <a-button type="link" icon="delete" @click="destroyFont(id)" />
        </div>
      </a-table>
    </a-layout-content>
  </a-layout>
</template>

<script>
import {
  getFonts,
  uploadFont,
  destroyFont,
} from "@/api/catalog-api/font-api/font.api.js";

export default {
  data() {
    return {
      data: null,
      columns: [
        {
          title: "Id",
          dataIndex: "id",
          key: "id",
          width: 80,
        },
        {
          title: "Name",
          dataIndex: "name",
          key: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "Source",
          dataIndex: "src",
          key: "authority",
          scopedSlots: { customRender: "src" },
          width: 80,
        },
        {
          title: "Destroy",
          dataIndex: "id",
          key: "destroy",
          scopedSlots: { customRender: "destroy" },
          width: 100,
        },
      ],
    };
  },
  mounted() {
    this.getFonts();
  },
  methods: {
    getFonts() {
      return getFonts().then((response) => {
        this.data = response.fonts;
        this.data.forEach((font) => {
          font.key = font.id;
          this.loadFont(font);
        });
      });
    },
    loadFont(font) {
      if (window.FontFace) {
        const chargeFont = new window.FontFace(font.name, `url(${font.src})`);
        return chargeFont.load().then((loaded) => document.fonts.add(loaded));
      }
      return null;
    },
    uploadFont() {
      let i = document.createElement("input");
      i.type = "file";
      i.accept = ".ttf, .otf";
      i.onchange = () => {
        if (!i.files.length) return;
        return uploadFont(i.files[0]).then((response) => this.getFonts());
      };
      i.click();
      return;
    },
    destroyFont(id) {
      const r = confirm("destroy font?");
      if (r) return destroyFont({ id }).then(() => this.getFonts());
      return;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
.fonts {
  height: 100%;
  background-color: $white;

  .fonts__header {
    background-color: $white;
  }

  .fonts__item--centered {
    text-align: center;
  }
}
</style>
